export const ross1000 = {
  title: "ROSS 1000 / Turismo5",
  subtitle: "إحصاءات التدفقات السياحية — إبلاغ إقليمي",

  fields: {
    region: "المنطقة",
    codice: "رمز المنشأة",
    codiceHint: "رمز المنشأة المخصص من المنطقة (حقل «codice»).",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    passwordHint: "بيانات اعتماد خدمة ويب ROSS 1000 (تصدرها المنطقة / GIES).",
    prodotto: "اسم البرنامج",
    camereDisponibili: "الغرف المتاحة",
    lettiDisponibili: "الأسرّة المتاحة",
    defaultTipoturismo: "نوع السياحة (افتراضي)",
    defaultMezzotrasporto: "وسيلة النقل (افتراضي)",
    useTestEndpoint: "استخدام بيئة الاختبار",
    endpointResolved: "نقطة النهاية",
    keepBlank: "(اتركه فارغًا لعدم التغيير)",
  },

  regionOptions: {
    sardegna: "سردينيا",
    lazio: "لاتسيو",
    veneto: "فينيتو",
    emilia_romagna: "إميليا-رومانيا",
    toscana: "توسكانا",
    piemonte: "بييمونتي",
    lombardia: "لومبارديا",
    liguria: "ليغوريا",
    marche: "ماركي",
    abruzzo: "أبروتسو",
    molise: "موليزي",
    calabria: "كالابريا",
    basilicata: "بازيليكاتا",
  },

  actions: {
    saveAndVerify: "حفظ وتحقق",
    updateCredentials: "تحديث بيانات الاعتماد",
    verifyConnection: "التحقق من الاتصال",
    saving: "جارٍ الحفظ...",
    verifying: "جارٍ التحقق...",
  },

  status: {
    connectionOk: "تم حفظ بيانات الاعتماد والتحقق من الاتصال بنجاح.",
    connectionError: "خطأ في الاتصال. تحقق من بيانات الاعتماد المُدخلة.",
    connectionPending: "لم يتم التحقق من الاتصال بعد. اضغط «التحقق من الاتصال» للتأكيد.",
  },

  validation: {
    codiceRequired: "رمز المنشأة مطلوب.",
    usernameRequired: "اسم المستخدم مطلوب.",
    passwordRequired: "كلمة المرور مطلوبة.",
    capacityRequired: "أدخل الغرف والأسرّة المتاحة.",
  },

  toasts: {
    saveSuccess: "تم حفظ بيانات الاعتماد والتحقق من الاتصال بنجاح.",
    saveWarning: "تم حفظ بيانات الاعتماد، لكن تعذّر التحقق من الاتصال.",
    saveError: "تعذّر حفظ بيانات الاعتماد.",
    testSuccess: "تم التحقق من الاتصال بـ ROSS 1000 بنجاح.",
    testError: "تعذّر التحقق من الاتصال.",
    statusActive: "تم تفعيل ROSS 1000.",
    statusInactive: "تم تعطيل ROSS 1000.",
  },
};
